module.exports = __webpack_public_path__ + "static/media/bg-bottom-green.3cdc3c3f.png";